module.exports = __webpack_public_path__ + "img/user_icon.d643b279.png";